// extracted by mini-css-extract-plugin
export var active = "_1q-9";
export var backButton = "_1q-8";
export var clone = "_1q-e";
export var collapseBar = "_1q-k";
export var collapseMode = "_1q-m";
export var collapsed = "_1q-o";
export var dimmed = "_1q-i";
export var dragHandle = "_1q-c";
export var dropdownIcon = "_1q-g";
export var expanding = "_1q-n";
export var hidden = "_1q-x";
export var iconContainer = "_1q-q";
export var iconSwapper = "_1q-w";
export var navItem = "_1q-6";
export var navItemIcon = "_1q-f";
export var navProfile = "_1q-7";
export var notificationCountBadge = "_1q-j";
export var notificationDot = "_1q-r";
export var optionsContainer = "_1q-h";
export var primaryNav = "_1q-0";
export var primaryNavDivider = "_1q-v";
export var primaryNavResizeHandle = "_1q-2";
export var primaryNavResizing = "_1q-1";
export var primaryNavTabSection = "_1q-u";
export var primaryTab = "_1q-p";
export var primaryTabIconBox = "_1q-s";
export var secondaryNav = "_1q-3";
export var selected = "_1q-t";
export var settingsNav = "_1q-4";
export var settingsNavItems = "_1q-5";
export var show = "_1q-d";
export var sideNav = "_1q-l";
export var teamItem = "_1q-a";
export var userProfileItem = "_1q-b";